import * as React from 'react';
import { useCallback, useMemo } from 'react';
import {
	Dropdown,
	DropdownCheckboxItem,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
	DropdownSeparator,
} from '../../../../../web/components-v2/Dropdown';
import { bs } from '../../../../../web/styles/styles';
import { DEAL_STAGE_OPTIONS } from '../../../../constants/dealStageOptions';

interface IProps {
	onChange: (stages: string[]) => void;
	selectedStages: string[];
}

export const DealStageMultiSelect: React.FC<IProps> = ({ onChange, selectedStages = [] }) => {
	const handleToggle = useCallback(
		(stageValue: string) => {
			const isSelected = selectedStages.includes(stageValue);
			if (isSelected) {
				onChange(selectedStages.filter(s => s !== stageValue));
			} else {
				onChange([...selectedStages, stageValue]);
			}
		},
		[selectedStages, onChange]
	);

	const handleClearAll = useCallback(() => {
		onChange([]);
	}, [onChange]);

	const dropdownMessage = useMemo(() => {
		if (selectedStages.length === 0) {
			return 'Select deal stages...';
		}
		if (selectedStages.length === 1) {
			const match = DEAL_STAGE_OPTIONS.find(opt => opt.value === selectedStages[0]);
			return match?.label ?? selectedStages[0];
		}
		return `${selectedStages.length} stages selected`;
	}, [selectedStages]);

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[bs.wFull]}>{dropdownMessage}</DropdownSelectTrigger>
			<DropdownContent>
				{DEAL_STAGE_OPTIONS.map(option => (
					<DropdownCheckboxItem
						key={option.value}
						checked={selectedStages.includes(option.value)}
						onCheckedChange={() => handleToggle(option.value)}
					>
						{option.label}
					</DropdownCheckboxItem>
				))}
				{selectedStages.length > 0 && (
					<>
						<DropdownSeparator />
						<DropdownItem onClick={handleClearAll}>Clear all</DropdownItem>
					</>
				)}
			</DropdownContent>
		</Dropdown>
	);
};
